<div id="w3l-appointment" style="width: 1000px;">
  <section class="appointment-section section-gap" >
    <div class="wrapper">


          <form action="#" method="post" >
            <div class="fields-grid" >
              <div class="styled-input" >
                <label style="width: 850px;color: rgb(70, 70, 247);font-weight: bolder;">Preparation Order # {{prepmasterID}}</label>
                <label style="width: 450px;">Edit discharge medications  Line</label>
              </div>

              <!---------- ********** Pre-Medication Treatment table *****--------->
                <div class="appointment-form-field" style="width: 1300px;border-collapse: collapse;text-align: center;">
                <label class="appointment-form-field header_lable" style="background-color: rgb(70, 70, 247);color: white;width: 8%;">  Category</label>
                <label class="appointment-form-field header_lable" style="background-color: rgb(70, 70, 247);color: white;width: 28%;">                            Item</label>
                <label class="appointment-form-field header_lable" style="background-color: rgb(70, 70, 247);color: white;width: 5%;">  Dose</label>
                <label class="appointment-form-field header_lable" style="background-color: rgb(70, 70, 247);color: white;width: 8%;">      Unit</label>
                <label class="appointment-form-field header_lable" style="background-color: rgb(70, 70, 247);color: white;width: 10%;">     Dosage form</label>
                <label class="appointment-form-field header_lable" style="background-color: rgb(70, 70, 247);color: white;width: 15%;">         Notes</label>
                <label class="appointment-form-field header_lable" style="background-color: rgb(70, 70, 247);color: white;width: 20%;"> Frequency</label>

              </div>

                <!------************** New Line  **********---------->
                <div class="appointment-form-field" style="width: 1300px;border-collapse: collapse;">
                  <select id="pharmgroups" name="pharmgroups0" required="" style="width: 8%;background-color: white;font-size: 80%;" [(ngModel)]="category" (change)="retriveItemsLookupCat()">
                    <option value="{{grs.serial}}" *ngFor="let grs of pharmGroupList; let i = index">{{grs.pharmacyGroupName}}</option>
                  </select>
                  <input type="text" name="itemcode" required="" placeholder="Code" style="width: 8%;background-color: white;font-size: small;" [(ngModel)]="drgserial" (change)="retriveItem()">
                  <span class="fa fa-search" aria-hidden="true" style="cursor: grab;" (click)="openDialog()"></span>
                  <input type="text" name="itemname" required="" placeholder="Item" style="width: 16%;background-color: white;font-size: small;" [(ngModel)]="drgName">

                  <input type="text" name="qty" required="" placeholder="00.00" style="width: 5%;background-color: white;font-size: small;" [(ngModel)]="perpDaose">
                  <select id="department" name="unit" required="" style="width: 8%;background-color: white;" [(ngModel)]="uOM" [value]="uOM">
                    <option value="{{unit.unCode}}" *ngFor="let unit of unitsList; let i = index">{{unit.unName}}</option>
                  </select>
                  <input type="text" name="duration" required=""style="width: 10%;background-color: white;font-size: small;" [(ngModel)]="prepDuration">

                  <input type="text" name="rout" required=""    style="width: 15%;background-color: white;font-size: small;" [(ngModel)]="preSolution">

                  <select id="solution" name="solution" required="" style="width:20%;background-color: white;" [(ngModel)]="prepRout" [value]="preSolution">
                    <option value="مره واحده ">مره واحده </option>
                    <option value="مرة صباحا و مرة مساءا">مرة صباحا و مرة مساءا</option>
                    <option value="ثلاث مرات يوميا">ثلاث مرات يوميا</option>
                    <option value="مره كل 6 ساعات">مره كل 6 ساعات</option>
                    <option value="مره كل 8 ساعات">مره كل 8 ساعات</option>
                    <option value="مره كل 12 ساعات">مره كل 12 ساعات</option>
                    
                  </select>
                </div>
              <BR>
              <BR>
            <div style="text-align: center;width: 1300px; ">
                <button type="button" class="theme-button btn" name="submit" (click)="submitPrepDet_Line1()" >Submit</button>
                <button type="button" class="theme-button btn" name="Delete" (click)="mesgDelete()"  >Delete</button>
                <button type="button" class="theme-button btn" name="New" (click)="CloseDialog()">Close</button>
            </div>
            <div class="clear">

            </div>
          </div>
          </form>




    </div>
  </section>
</div>

